const VideosDeepTech = [
  {
    video_id: "J8sx3GGTqCQ",
    title: "NOW JAZZ (MIDNIGHT MIX)",
    artist: "GOLFOS",
  },
  {
    video_id: "qMoYVQC3BDw",
    title: "Get Down Again",
    artist: "Enzo Siragusa",
  },
  {
    video_id: "xQzi7n2zCYg",
    title: "Noir Infusion",
    artist: "Chris Stussy, Toman",
  },
  {
    video_id: "bmlNEX5pLWs",
    title: "Loaded",
    artist: "Destructo Feat. Yo Gotti",
  },
  {
    video_id: "9hJ8NMys_mg",
    title: "XTC IV (Kornél Kovács Remix)",
    artist: "X-Coast",
  },
  {
    video_id: "4usXXs5JeS4",
    title: "Phonica (Viktor Udvari Remix)",
    artist: "MnD",
  },
  {
    video_id: "LHtdDjOuF00",
    title: "The System",
    artist: "Peppou",
  },
  {
    video_id: "Szjc1v_LzqA",
    title: "Fernet",
    artist: "Del Fonda",
  },
  {
    video_id: "gfcxyJF3-IM",
    title: "Cat (Archie Hamilton Remix)",
    artist: "Noha",
  },
  {
    video_id: "ew09c5_BMmI",
    title: "Planet of the Apes (M.A.N.D.Y. Remix)",
    artist: "Tantsui",
  },
  {
    video_id: "cLozDhBYViY",
    title: "Chicago",
    artist: "Alex Gamez, Alex Sounds",
  },
];

export default VideosDeepTech;
